import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { FileSystemHelper } from '../../helpers/file-system.helper';
import { FileHelper, PathInfoType } from '../../helpers/file-system/file.helper';
import { FileUploadHelperInterface } from './file-upload-helper.interface';
import { FileUploaderBaseHelper } from './file-uploader-base.helper';

export class FileUploaderDesktopHelper extends FileUploaderBaseHelper implements FileUploadHelperInterface {

    protected blob: Blob;

    protected getBlob(path: string): Observable<Blob> {
        return of(this.blob);
    }

    async prepare(path: string): Promise<any> {

        const info = FileHelper.parsePath(path);

        switch (info.type) {
            case PathInfoType.BLOB: {
                return FileSystemHelper.objectUrlToBlob2(path)
                    .then(blob => this.blob = blob);
            }
            case PathInfoType.DATA_URI: {
                this.blob = FileHelper.dataUrlToBlob(path);
                return this.blob;
            }
            default: {
                throw Error('path is not of type BLOB or DATA_URI');
            }
        }
    }

    readChunk(path: string, index: number, size: number): Observable<Blob> {
        return this.getBlob(path)
            .map(blob => {
                const from = Math.min(index * size, blob.size);
                const to = Math.min((index + 1) * size, blob.size);
                return blob.slice(from, to, blob.type);
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/lib/file-uploader/file-uploader-desktop.helper.ts